export default {
    user: {
        id: -1,
        firstname: '',
        lastname: '',
        email: 0,
        phone: 0,
        status: null,
        type: '',
        token: ''
    }
    
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js